<p>quote-fetching works!</p>
